<script setup lang="ts">
  import { useLayout } from './lib'

  const currentLayoutComponent = useLayout()

  const router = useRouter()
  const routerIsReady = ref(false)
  router
    .isReady()
    .then(() => {
      routerIsReady.value = true
    })
    .catch(() => {})
</script>

<template>
  <div>
    <component
      :is="currentLayoutComponent"
      v-if="routerIsReady"
    >
      <slot />
    </component>
  </div>
</template>
